import { useId, useState, type FormEvent } from 'react'
import { anmeldeFehlerText, useAuth } from '../lib/auth'

/**
 * Eine Anmeldeseite, mehr nicht (§5.2). Keine Selbstregistrierung — das Konto
 * ist dasselbe wie in der App und wird serverseitig eingerichtet.
 */
export default function Anmelden() {
  const { anmelden, passwortZuruecksetzen } = useAuth()
  const emailId = useId()
  const passwortId = useId()

  const [email, setEmail] = useState('')
  const [passwort, setPasswort] = useState('')
  const [laeuft, setLaeuft] = useState(false)
  const [fehler, setFehler] = useState<string | null>(null)
  const [hinweis, setHinweis] = useState<string | null>(null)

  async function absenden(ereignis: FormEvent) {
    ereignis.preventDefault()
    setFehler(null)
    setHinweis(null)
    setLaeuft(true)
    try {
      await anmelden(email.trim(), passwort)
      // Der Rest läuft über onAuthStateChanged im AuthAnbieter.
    } catch (f) {
      setFehler(anmeldeFehlerText(f))
    } finally {
      setLaeuft(false)
    }
  }

  async function zuruecksetzen() {
    setFehler(null)
    setHinweis(null)
    if (!email.trim()) {
      setFehler('Trag zuerst deine E-Mail-Adresse ein.')
      return
    }
    try {
      await passwortZuruecksetzen(email.trim())
      setHinweis(
        `Wenn es zu ${email.trim()} ein Konto gibt, ist eine Mail zum ` +
          'Zurücksetzen unterwegs.',
      )
    } catch (f) {
      setFehler(anmeldeFehlerText(f))
    }
  }

  return (
    <main className="anmelden">
      <form className="karte anmelden-karte" onSubmit={absenden}>
        <div>
          <p className="marke">Kinderspiel</p>
          <h1>Moderation</h1>
        </div>

        <div className="feld">
          <label htmlFor={emailId}>E-Mail</label>
          <input
            id={emailId}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
            autoFocus
          />
        </div>

        <div className="feld">
          <label htmlFor={passwortId}>Passwort</label>
          <input
            id={passwortId}
            type="password"
            value={passwort}
            onChange={(e) => setPasswort(e.target.value)}
            autoComplete="current-password"
            required
          />
        </div>

        {fehler && (
          <p className="meldung meldung-fehler" role="alert">
            {fehler}
          </p>
        )}
        {hinweis && (
          <p className="meldung meldung-hinweis" role="status">
            {hinweis}
          </p>
        )}

        <button className="knopf knopf-haupt" type="submit" disabled={laeuft}>
          {laeuft ? 'Melde an …' : 'Anmelden'}
        </button>

        <button className="knopf knopf-still" type="button" onClick={zuruecksetzen}>
          Passwort vergessen
        </button>
      </form>
    </main>
  )
}
